import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import "./index.css";

// The bundle loaded, so the boot-recovery guard in index.html stands down and
// may fire again on a later stale load.
window.__ddBooted = true;
try { sessionStorage.removeItem("dd-boot-recover"); } catch { /* storage unavailable */ }

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* Outer net: catches crashes in the shell (Sidebar/Topbar/App), which the
          inner route-level boundary can't — a shell throw used to white-screen. */}
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);
